























































import useContactLabels from "@/composables/v2.1/useContactLabels";
import { ContactFilterInterface } from "@/interfaces/contactFilter.interface";
import { computed, defineComponent, PropType, Ref, ref } from "@vue/composition-api";
import {
    BDropdown,
    BDropdownForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BListGroup,
    BListGroupItem,
    BTab,
    BTabs,
    VBTooltip,
} from "bootstrap-vue";

export default defineComponent({
    components: {
        BDropdown,
        BDropdownForm,
        BTab,
        BTabs,
        BListGroup,
        BListGroupItem,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormSelect,
        BFormSelectOption,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        value: {
            required: true,
            type: Object as PropType<ContactFilterInterface>,
        },
    },
    setup(props, context) {
        /**
         * LABELS
         */
        const { contactLabels, fetchContactLabels } = useContactLabels();
        fetchContactLabels({ params: { fields: "id,name,color" } });

        //Default filter behaviour is showing results with at least one selected value

        const filters = computed<ContactFilterInterface>({
            get() {
                return props.value;
            },
            set(value) {
                context.emit("emit", value);
            },
        });

        const active = computed(() => {
            if (filters.value.labels.length) {
                return true;
            }
        });

        return {
            contactLabels,
            filters,
            active,
        };
    },
});
